import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useT } from "../i18n";
// import { URGENT_OPTIONS } from "../data/company";
// import { eur } from "../lib/format";
import { getSession } from "../lib/auth";
import { api } from "../lib/api";

/** GET /api/pricing (public). */
interface PublicPricing {
  launch: { enabled: boolean; listingLimit: number | null; noticeDays: number };
  sponsor: {
    enabled: boolean;
    options: { days: number; priceCents: number }[];
  };
}
import { ORGANIZATION_ID, absoluteUrl, breadcrumbLd, useSeo } from "../lib/seo";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";

/** /pricing: free launch offer for rental companies, plus the sponsored listing add-on. */
export default function Pricing() {
  const t = useT();
  const page = t.pricingPage;
  useSeo({
    title: t.seo.pricing.title,
    fullTitle: true, // "… – LE COIN VTC" is part of the title
    description: t.seo.pricing.description,
    path: "/pricing",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "Service",
        name: t.seo.pricing.title,
        description: t.seo.pricing.description,
        provider: { "@id": ORGANIZATION_ID },
        url: absoluteUrl("/pricing"),
        // Launch offer: free for rental companies
        offers: { "@type": "Offer", name: page.launchTitle, price: 0, priceCurrency: "EUR", url: absoluteUrl("/pricing") },
      },
      breadcrumbLd([[t.seo.breadcrumbHome, "/"], [t.seo.pricing.title]]),
    ],
  });
  // Signup button only for visitors; a logged-in user already has an account
  const loggedIn = !!getSession();
  // Sponsored prices set in the admin panel; the defaults show until (or if) it loads
  // const [sponsorOptions, setSponsorOptions] = useState(URGENT_OPTIONS);
  useEffect(() => {
    api
      .get<PublicPricing>("/pricing")
      // .then(({ data }) =>
      //   setSponsorOptions(
      //     data.sponsor.enabled
      //       ? data.sponsor.options.map((o) => ({
      //           days: o.days,
      //           price: o.priceCents / 100,
      //         }))
      //       : [],
      //   ),
      // )
      .catch(() => {
        // Keep the default prices
      });
  }, []);

  return (
    <div className="flex min-h-screen flex-col bg-white">
      <Header activeHref="/pricing" />

      <main className="mx-auto w-full max-w-300 flex-1 px-4 pt-12 pb-24 sm:px-6">
        <div className="mb-8 text-center">
          <h1 className="m-0 text-2xl sm:text-3xl font-medium tracking-[-0.01em] sm:text-[40px]">
            {page.title}
          </h1>
          <p className="mx-auto mt-3 mb-0 max-w-auto text-[15px] leading-normal text-muted">
            {page.intro}
          </p>
        </div>

        <section className="grid gap-6 rounded-card border border-brand p-6 sm:grid-cols-2 sm:p-7">
          <div className="flex flex-col items-start">
            <span className="rounded bg-tone-blue-bg px-2 py-1 text-[11px] font-medium text-tone-blue-fg">
              {page.launchBadge}
            </span>
            <h2 className="m-0 mt-3 text-xl font-medium">{page.launchTitle}</h2>
            <b className="mt-2 text-4xl font-semibold">{page.launchPrice}</b>
            <span className="mt-1 text-xs text-muted">{page.launchNote}</span>
            {!loggedIn && (
              <Link
                to="/partners/signup"
                className="mt-4 inline-flex h-10 items-center rounded bg-brand px-4.5 text-[13px] font-medium text-white no-underline hover:bg-brand-dark"
              >
                {page.launchCta}
              </Link>
            )}
          </div>
          <ul className="m-0 grid list-none content-start gap-2.5 p-0 text-[13px] text-ink-soft">
            {page.launchFeatures.map((feature) => (
              <li key={feature} className="flex gap-2.5">
                <span className="text-brand" aria-hidden="true">
                  ✓
                </span>
                {feature}
              </li>
            ))}
          </ul>
        </section>

        {/* <section className="mt-3 rounded-card border border-line-strong p-5 sm:px-6">
          <h2 className="m-0 text-[15px] font-medium">{page.laterTitle}</h2>
          <p className="m-0 mt-1.5 text-[13px] leading-normal text-muted">
            {page.laterText}
          </p>
        </section> */}
{/* 
        {sponsorOptions.length > 0 && (
          <section className="mt-3 flex flex-wrap items-center gap-4 rounded-card border border-line-strong p-5 sm:px-6">
            <span className="rounded bg-brand px-2 py-1 text-[10px] font-semibold uppercase tracking-[.06em] text-white">
              {page.sponsoredBadge}
            </span>
            <div className="min-w-55 flex-1">
              <h2 className="m-0 text-[15px] font-medium">
                {page.sponsoredTitle}
              </h2>
              <p className="m-0 mt-0.5 text-[13px] leading-normal text-muted">
                {page.sponsoredText}
              </p>
            </div>
            <div className="text-right text-[13px] font-medium leading-relaxed">
              {sponsorOptions.map((o) => (
                <div key={o.days}>
                  {page.sponsoredPrice(o.days, eur(o.price))}
                </div>
              ))}
            </div>
          </section>
        )}

        <p className="mt-6 mb-0 text-center text-[11px] leading-normal text-faint">
          {page.footnote}
        </p> */}
      </main>

      <Footer />
    </div>
  );
}
